import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { formatNumero, formatData } from "@/lib/museo";

export const PromiseCard = ({ promise, index = 0 }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.7, ease: "easeOut", delay: Math.min(index * 0.04, 0.4) }}
    >
      <Link
        to={`/promessa/${String(promise.numero).padStart(6, "0")}`}
        data-testid={`promise-card-${promise.numero}`}
        className="group block h-full bg-museo-surface border border-museo-border p-8 md:p-10 rounded-none md:rounded-sm transition-all duration-500 hover:border-museo-accent/50 hover:bg-museo-surfaceHover hover:-translate-y-1"
      >
        <div className="flex items-center justify-between mb-6">
          <span className="font-mono text-xs tracking-widest text-museo-accent">
            Messaggio {formatNumero(promise.numero)}
          </span>
          <ArrowUpRight className="w-4 h-4 text-museo-muted group-hover:text-museo-accent transition-colors duration-500" />
        </div>
        <p className="font-serif text-xl md:text-2xl leading-relaxed text-museo-text mb-4">
          “{promise.testo}”
        </p>
        <p className="font-serif italic text-sm text-museo-muted mb-6">
          {promise.firma ? `— ${promise.firma}` : "— Anonimo"}
        </p>
        <div className="flex items-center justify-between mt-auto">
          <span className="text-sm text-museo-muted font-light">{formatData(promise.data)}</span>
          <span className="text-xs uppercase tracking-[0.2em] text-museo-muted group-hover:text-museo-accent transition-colors duration-500">
            Apri
          </span>
        </div>
      </Link>
    </motion.div>
  );
};
